

































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ZoomableImage from '../../ZoomableImage/ZoomableImage.vue'
import { MediaFileData, FileStatus, FileType } from '../types'

@Component({
  data() {
    return {
      FileType,
    }
  },
  components: {
    ZoomableImage,
  },
})
export default class FilesListRowScroll extends Vue {
  FileStatus: any = FileStatus

  @Prop() readonly filesData!: Array<MediaFileData>

  @Prop() readonly disabled!: boolean
}
